export { CompanyLogoAndName } from './CompanyLogoAndName';
